import { useStagesStore } from 'hooks/useStagesStore'
import { modalAvailableStages } from '@shell/Topbar/types'
import { useOrderResultTotal } from '@order/hooks/useOrderTotal'
import { useCurrentSummaryModal } from '@order/modals/Summary/SummaryModal'
import { useTotalDiscountAmount } from '@order/useDiscounts'
import { useActiveGlassesIndex } from '@order/hooks/useActiveOrderItem'
import CartButtonPrice from './CartButtonPrice'

export default function CartButton() {
  const stage = useStagesStore((state) => state.active)
  const isModal = useStagesStore((state) => state.isModal)
  const setIsModal = useStagesStore((state) => state.setIsModal)
  const { frame } = useActiveGlassesIndex()

  // DISPLAY LOGIC
  const isStageAllowed = stage && modalAvailableStages.includes(stage)
  const disabled = !isStageAllowed || !frame

  const onPress = () => {
    if (disabled) {
      return
    }
    setIsModal(!isModal)
  }

  // PRICE CALCULATION
  const summaryProps = useCurrentSummaryModal()

  const { order, result, deals, discounts } = summaryProps.order
  const total = useOrderResultTotal({
    result,
    order,
    deals,
  })

  const discountAmount = useTotalDiscountAmount({
    orderTotal: total,
    discounts,
  })

  return (
    <CartButtonPrice
      price={discountAmount.discountedDisplay}
      disabled={disabled}
      onPress={onPress}
    />
  )
}
